module.exports = __webpack_public_path__ + "media/point-3.4fb404b0.mp3";